import { getCurrentYearIdFromLS } from './yearUtils';

export const extendFetchBody = (body: any) => {
  const YearId = getCurrentYearIdFromLS();

  return YearId ? { ...body, YearId } : body;
};
